import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import AllDataLikeProduct from "./AllDataLikeProduct";
import 'react-tabs/style/react-tabs.css';

const AllDataMain = () => {
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        padding: 16,
        flexDirection: "column",
      }}
    >
      <Tabs >
        <TabList>
          <Tab>All Data</Tab>
        </TabList>
        <TabPanel>
          <AllDataLikeProduct />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default AllDataMain
